import { render, staticRenderFns } from "./project-list-item.vue?vue&type=template&id=dbd175d4"
import script from "./project-list-item.vue?vue&type=script&lang=js"
export * from "./project-list-item.vue?vue&type=script&lang=js"
import style0 from "./project-list-item.vue?vue&type=style&index=0&id=dbd175d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports